import React, { useContext, useState } from "react";
import ReactModal from "react-modal";
import Loading from "./Loading";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import { Label, Select } from "./styledComponent/formInputs";
import { updateOrderStatus } from "../api/adminApi";
import Button from "../common/Button";

const UpdateOrderStatus = ({ currentStatus, setRefresh, id }) => {
  const { user } = useContext(Context);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setstatus] = useState(currentStatus ? currentStatus : "");

  const statusList = [
    "Pending",
    "Processing",
    "Intransit",
    "Delivered",
    "Cancelled",
    "Failed",
  ];

  const handleUpdateStatus = async () => {
    if (user?.id) {
      if (!status) {
        toast.warn("Select a status");
        return "";
      }
      setLoading(true);
      try {
        const data = {
          status,
        };

        const res = await updateOrderStatus(id, data, user?.accessToken);

        toast.success("Status updated Successfully");
        setModalIsOpen(false);
        setLoading(false);
        setRefresh((curr) => !curr);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };
  return (
    <div>
      <Button width={180} onClick={() => setModalIsOpen(true)}>
        Update Status
      </Button>
      <ReactModal
        className="modalMain"
        overlayClassName="modal-overlayCenter"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Cart Modal"
      >
        <div className="tableMenu__modal">
          <h3 style={{ marginBottom: 10 }}>Update Order Status</h3>
          <p style={{ marginBottom: 20 }}>
            Current Status: {currentStatus || ""}{" "}
          </p>

          <div className="addProduct__form__item">
            <Label htmlFor="status">
              Select Staus <span>*</span>
            </Label>
            <Select
              id="status"
              onChange={(e) => setstatus(e.target.value)}
              value={status}
            >
              <option value="">--</option>
              {statusList.map((item, i) => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </Select>
          </div>

          <div className="tableMenu__modal__btn">
            <button
              className="tableMenu__modal__btn__item"
              onClick={() => setModalIsOpen(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleUpdateStatus}
              className="tableMenu__modal__btn__item delete"
            >
              {loading ? <Loading button={true} /> : "Save"}
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default UpdateOrderStatus;
